import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';

/**
 *  ADMIN › PUSH-ÉRTESÍTÉS – állapot, ki-bekapcsolás, próba (backend/push-ertesito.js, push-kuldo.js).
 *
 *  Feljegyzésről és üzenetről az app push-értesítést küld a tanulónak és a családjának,
 *  közvetlenül a Google-nek (Android) és az Apple-nek (iOS). A kulcsok központiak, a rendszerbe
 *  építve – az intézménynek nincs mit beállítania, csak ki-be kapcsolhatja.
 */
@Component({
  selector: 'app-admin-push-beallitas',
  templateUrl: './push-beallitas.component.html',
  styleUrls: ['./push-beallitas.component.scss'],
})
export class AdminPushBeallitasComponent implements OnInit {
  betolt = false;
  ment = false;
  proba = false;
  b: any = { enabled: true, fcm: null, apns: null, android_db: 0, ios_db: 0, szemely_db: 0, naplo: [] };

  readonly forrasNev: Record<string, string> = { feljegyzes: 'Feljegyzés', uzenet: 'Üzenet', proba: 'Próba' };

  constructor(private http: HttpClient, private data: DataService) {}

  ngOnInit() { this.toltes(); }

  async toltes() {
    this.betolt = true;
    try {
      this.b = await firstValueFrom(this.http.get<any>('/api/push/beallitas'));
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Nem sikerült betölteni a push-beállítást.', 'error');
    } finally { this.betolt = false; }
  }

  async mentes() {
    this.ment = true;
    try {
      await firstValueFrom(this.http.put('/api/push/beallitas', { enabled: !!this.b.enabled }));
      this.data.sendToast('A push-értesítés beállítása mentve.', 'success');
      await this.toltes();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Nem sikerült menteni.', 'error');
    } finally { this.ment = false; }
  }

  async probaKuldes() {
    this.proba = true;
    try {
      const r: any = await firstValueFrom(this.http.post('/api/push/proba', {}));
      this.data.sendToast(r?.hiba
        ? `Próba: ${r.eredmeny} eszközre ment ki; hiba: ${r.hiba}`
        : `Próba-értesítés elküldve (${r?.eszkoz_db || 0} eszköz).`, r?.hiba ? 'warning' : 'success');
      await this.toltes();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A próba nem sikerült.', 'error');
    } finally { this.proba = false; }
  }
}
